import { Box, type BoxProps, rem } from "@mantine/core";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { MDA, MDCode, MDTable } from "src/components/markdown/MarkdownComponents";
import type { PluggableList } from "unified";

const markdownPreviewComponents = {
    table: MDTable,
    code: MDCode,
    a: MDA,
};

type PromptTemplateMarkdownPreviewProps = {
    content: string;
    maxHeight?: number | string;
} & Pick<BoxProps, "p">;

export function PromptTemplateMarkdownPreview({
    content,
    maxHeight = rem(400),
    p = "sm",
}: PromptTemplateMarkdownPreviewProps) {
    return (
        <Box className="markdown" p={p} style={{ maxHeight, overflow: "auto", textAlign: "left" }}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw] as PluggableList}
                components={markdownPreviewComponents}
            >
                {content}
            </ReactMarkdown>
        </Box>
    );
}
